export const audioDeviceSelectorStyles = `
  .qbi-root {
    width: 300px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
    background-color: var(--catchup-white);
    border-radius: var(--rad-catchup-medium);
    box-shadow: var(--shadow-input);
  }
  .qbi-title {
    font-weight: 700;
    font-size: var(--fs-lg);
    text-align: center;
  }
  .qbi-loading-wrapper {
    display: flex;
    justify-content: center;
    padding: 1rem;
  }
  .qbi-error {
    color: var(--catchup-red);
    padding: 0.5rem;
    border-radius: var(--rad-catchup-medium);
  }
  /* "Try again" recovery CTA is now the shared library PrimaryButton. */
  .qbi-retry-slot {
    margin-top: 0.5rem;
  }
  .qbi-field-mic {
    margin-bottom: 0.75rem;
  }
`;
